/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Showcase_Use_Case_Data_AnalysisInputs */



/**
* | output |
* | --- |
* | "Data analysis" |
*
* @param {Model_Showcase_Use_Case_Data_AnalysisInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_showcase_use_case_data_analysis = /** @type {((inputs?: Model_Showcase_Use_Case_Data_AnalysisInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Showcase_Use_Case_Data_AnalysisInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datenanalyse")
	return /** @type {LocalizedString} */ ("Data analysis")
});